import { c as _c } from "react/compiler-runtime";
import SVGelem from '@components/SVGelem/SVGelem';
import { useViewport } from '@lib/tools/hooks/useViewport';
import cn from 'classnames';
import { useState } from 'react';
import style from './ButtonSend.module.scss';
const ButtonSend = t0 => {
  const $ = _c(17);
  const {
    className,
    handleFunction,
    iconStyle,
    page,
    testId
  } = t0;
  const [iconHover, setIconHover] = useState(false);
  const {
    isMobile
  } = useViewport();
  let t1;
  if ($[0] !== isMobile) {
    t1 = () => !isMobile && setIconHover(true);
    $[0] = isMobile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleMouseOver = t1;
  let t2;
  if ($[2] !== isMobile) {
    t2 = () => !isMobile && setIconHover(false);
    $[2] = isMobile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleMouseOut = t2;
  let iconName;
  if (iconHover) {
    iconName = page === "visual" ? "#arrow-small-black" : "#arrow-small-white";
  } else {
    iconName = page === "visual" ? "#arrow-small-white" : "#arrow-small-black";
  }
  const iconClass = page === "visual" ? iconStyle : style.buttonSendIcon;
  let t3;
  if ($[4] !== className || $[5] !== page) {
    t3 = page === "visual" ? className : cn(style.buttonSend, className);
    $[4] = className;
    $[5] = page;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = testId ? testId : "formSend";
  let t5;
  if ($[7] !== iconClass || $[8] !== iconName) {
    t5 = <SVGelem href={iconName} className={iconClass} />;
    $[7] = iconClass;
    $[8] = iconName;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleFunction || $[11] !== handleMouseOut || $[12] !== handleMouseOver || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <button className={t3} onClick={handleFunction} type="submit" onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} aria-label={"\u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C"} data-testid={t4}>{t5}</button>;
    $[10] = handleFunction;
    $[11] = handleMouseOut;
    $[12] = handleMouseOver;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default ButtonSend;